import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Home from './Components/Home';
import ComingSoon from './Components/ComingSoon';
import WhyBanner from './Components/WhyBanner';
import Contact from './Components/Contact';
import WhatBanner from './Components/WhatBanner';
import Service from './Components/Service';
import Gallery from './Components/Gallery';
import Video from './Components/VideoPage';
import Faq from './Components/Faq';
import ProductBanner from './Components/ProductBanner';
import LoaderPage from './Components/LoaderPage'; // Import the LoaderPage component
import ThermographyBenefits from './Components/ThermographyBenefits';


// Custom Hook to handle page load on navigation
const usePageLoading = () => {
  const [loading, setLoading] = useState(true);
  const location = useLocation(); // Get the current location from react-router-dom

  useEffect(() => {
    setLoading(true); // Start loading whenever the location changes
    const timer = setTimeout(() => {
      setLoading(false); // Stop loading after a certain time
    }, 1000); // 1-second delay, adjust as necessary

    return () => clearTimeout(timer); // Cleanup the timer when the component unmounts
  }, [location]); // Depend on location so it triggers on route change

  return loading;
};

function App() {
  return (
    <Router>
      <div className="App">
        <MainApp />
      </div>
    </Router>
  );
}

const MainApp = () => {
  const loading = usePageLoading(); // Get loading state

  return (
    <>
      {/* Conditionally render loader or the main content */}
      {loading ? (
        <LoaderPage /> // Show the loader while loading
      ) : (
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/why" element={<WhyBanner />} />
          <Route path="/what" element={<WhatBanner />} />
          <Route path="/service" element={<Service />} />
          <Route path="/product" element={<ProductBanner />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/video" element={<Video />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/thermography" element={<ThermographyBenefits />} />

        </Routes>
      )}
    </>
  );
}

export default App;
